import ajax from './ajax'
import { bikeConfigToQuery } from './bike-config'

export function addToCart(bikeConfig, quantity) {
  return ajax('POST', '/customizer-add-to-cart/?custom-addtocart=true', {
    payload: {
      bikeConfig: bikeConfigToQuery(bikeConfig),
      quantity
    }
  })
}
